import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { updateDocumentTitle } from '../../actions/common';
import { Bem } from '../../service/Bem/Bem';

import './NoRightsPage.css';
import * as keyset from './NoRightsPage.i18n';

const i18n = i18nFactory(keyset);

interface NoRightsPageProps {
    updateDocumentTitle: typeof updateDocumentTitle;
}

export const NoRightsPage = (props: NoRightsPageProps) => {
    props.updateDocumentTitle(i18n('title'));

    return (
        <div className={Bem.cls('no-rights-page')}>
            <h1 className={Bem.cls('no-rights-page', 'title')}>{403}</h1>
            <div className={Bem.cls('no-rights-page', 'subtitle')}>{i18n('be-sure-no-error')}</div>
        </div>
    );
};
